import React from 'react'

import * as userActionCreators from '../actions/user';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import AdminView from './Admin/AdminView'
import SalesView from './Sales/SalesView'
import Notification from './Notifications'
import LoadingWheel from './Loader' 
import PropTypes from "prop-types";
import CircularProgress from '@material-ui/core/CircularProgress';
import { browserHistory } from 'react-router';

import {
    ADMIN_ROLE,
    MARKETING_ROLE,
    WAREHOUSE_ROLE,
    LOGISTIC_ROLE,
    SALES_ROLE,
    POS_ROLE,
} from '../constants'


function mapStateToProps(state) {
    return {
        isAuthenticating: state.auth.isAuthenticating,
        userDetails: state.user.detail,
        isLoading: state.user.loadingUser,
        userId: state.auth.userId,
        userName: state.user.userName,
        userEmail: state.user.userEmail,
        userPhone: state.user.userPhone,
        userTIN: state.user.userTIN,
        userRoles: state.user.userRoles,
        changePassword: state.user.changePassword
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(userActionCreators, dispatch);
}



@connect(mapStateToProps, mapDispatchToProps)
class LandingView extends React.Component {

    constructor(props){
        super(props)
        this.state  = {
            open: false
        }
        this.handleClose = this.handleClose.bind(this)
        this.loadProfile = this.loadProfile.bind(this)
    }
    
    componentWillMount() {
        this.props.fetchUserDetails(this.props.userId);
    }

    handleClose(event, reason) {
        if (reason === 'clickaway') {
            return;
        }

        this.setState({ open: false });
    }

    loadProfile(){
        let view = null;
        if(this.props.changePassword){
            browserHistory.push('/user_settings')
        }
        if(this.props.userRoles.includes(ADMIN_ROLE)){
            view = <AdminView/>
        }
        else if(this.props.userRoles.includes(SALES_ROLE) || this.props.userRoles.includes(POS_ROLE) ){
            view = <SalesView/>
        }else{
            view = <h1>NOPE!</h1>
        }
        return view;
    }
    render() {
        // TODO: redefine considering roles
        return (
            <div>
                {this.props.isLoading
                ?<div  style={{marginTop:70}} className="col-md-6 col-md-offset-5">
                <CircularProgress
                            size={80}
                            color='primary'
                            thickness={3}
                            style={{display: 'center'}}/>
                </div>
            :<div>{ this.props.userRoles  &&  this.loadProfile() }</div>
            }
                <Notification
                    onClose={this.handleClose}
                    open={this.state.open}
                    variant="success"
                    message="This is a success message!"
                />
            </div>
        )
    }

}


LandingView.propTypes = {
    fetchUserDetails: PropTypes.func,
};

export default LandingView


// WEBPACK FOOTER //
// ./src/components/LandingView.js